/**
 * Набор хелперов для работы с файлами
 */

/**
 * Конвертирует файл в его DataURL представление.
 */
export const toDataURL = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            if (reader?.result !== null) {
                resolve(reader.result as string);
            } else {
                reject();
            }
        };
        reader.onerror = reject;
    });

/**
 * Конвертирует DataURL представление в файл.
 */
export const fromDataURL = (dataurl: string, filename: string) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n) {
        u8arr[n - 1] = bstr.charCodeAt(n - 1);
        n -= 1;
    }
    return new File([u8arr], filename, { type: mime });
};

export const dataUrlToBlob = (dataUrl) => {
    const arr = dataUrl.split(',');
    const mimeString = arr[0].match(/:(.*?);/)[1];
    const byteString = atob(arr[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });
    return blob;
};

export const getDataUrlName = (dataUrl) => {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    return Math.round(+new Date() / 1000) + '.' + mime.split('/').pop();
};

/**
 * Открывает диалог выбора файла и возвращает первый выбранный.
 */
export const pickFile = (): Promise<File> =>
    new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.onchange = async (e) => {
            const fileEvent = e?.target as HTMLInputElement;
            if (fileEvent === null || fileEvent.files === null || !fileEvent.files.length) {
                return reject();
            }
            return resolve(fileEvent.files[0]);
        };
        input.onerror = reject;
        input.click();
    });
